import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSiteExtId } from '../../settings/reducer';
import { selectDetergentPods, selectDetergentReadings } from '../reducer';
import { getDetergentReadings } from '../actions';
import { generateToastr } from '../../../core/toastMessages';
import DetergentTracker from './DetergentTracker';
import { selectMyChartsWashCounts } from '../../overview/reducer';
import { selectHourlyWashCounts } from '../../wash-counts/reducer';
import { getOverviewWashCounts } from '../../overview/actions';
import Loader from '../../../core/components/Loader';
import { fetchHourlyWashCounts } from '../../wash-counts/actions';

interface Props {
  fromDate: any;
  untilDate: any;
  tabType: any;
  detergents: any;
}

const DetergentTrackerDataGetter = (props: Props) => {
  const dispatch = useDispatch();
  const siteId = useSelector(selectSiteExtId);
  const detergentPods = useSelector(selectDetergentPods);
  const overviewWashCounts = useSelector(selectMyChartsWashCounts);
  const hourlyWashCounts = useSelector(selectHourlyWashCounts);
  const untilDate = moment().endOf('day').toISOString();
  const fromDate = moment().subtract(7, 'days').startOf('day').toISOString();
  const startToday = moment().startOf('day').toISOString();
  const endToday = moment().endOf('day').toISOString();
  const detergentReadingsData = useSelector(selectDetergentReadings);
  const detergentIds = props.detergents?.map((container: { id: any }) => container.id) || [];
  const currentDetergentPod = detergentPods.find((pod: any) => pod.title === props.tabType);
  const detergentContainerIds =
    currentDetergentPod?.detergentContainers?.map((container: { id: any }) => container.id) || [];

  const fetchDetergentReadings = () => {
    dispatch(getDetergentReadings({ fromDate, untilDate, detergentContainerIds, detergentIds }));
  };
  const getHourlyWashCounts = () => {
    dispatch(
      fetchHourlyWashCounts(
        moment(startToday).format('YYYY-MM-DD'),
        moment(endToday).format('YYYY-MM-DD')
      )
    );
  };
  const fetchWashCounts = () => {
    dispatch(getOverviewWashCounts(moment(props.fromDate).toISOString()));
  };
  useEffect(fetchDetergentReadings, [siteId, props.fromDate, props.untilDate, detergentPods]);

  useEffect(fetchWashCounts, [props.fromDate, siteId]);
  useEffect(() => {
    getHourlyWashCounts();
  }, [props.fromDate, props.untilDate, siteId]);

  return (
    <>
      {detergentContainerIds?.length > 0 ? (
        <DetergentTracker
          chartData={detergentReadingsData}
          detergents={props.detergents}
          washCounts={overviewWashCounts}
          hourlyWashCounts={hourlyWashCounts}
        />
      ) : (
        <Loader />
      )}
    </>
  );
};

export default DetergentTrackerDataGetter;
